

import { Modal, ModalTitle, ModalContent, ModalFooter, Button } from '@utahdts/utah-design-system';
import WaterSystemSearchInput from './WaterSystemSearchInput';
import { useWaterSystemSearchModal } from './WaterSystemSearchModalContext';
import { useHistory, useLocation } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import './WaterSystemSearchModal.css';



const WaterSystemSearchModal = ({ selectedWaterSystem, setSelectedWaterSystem }) => {
  const { showSystemSelectModal, setShowSystemSelectModal } = useWaterSystemSearchModal();
  const history = useHistory();
  const closedByNavigationRef = useRef(false);
  const location = useLocation();

  // Prevent modal from reopening after navigation
  useEffect(() => {
    if (closedByNavigationRef.current && showSystemSelectModal) {
      setShowSystemSelectModal(false);
      closedByNavigationRef.current = false;
    }
  }, [showSystemSelectModal, setShowSystemSelectModal]);

  // Handler for Cancel button
  const handleCancel = () => {
    setShowSystemSelectModal(false);
    // Only redirect if current route contains 'water-system-redirect'
    if (window.history.length > 1 && location.pathname.includes('water-system-redirect')) {
      closedByNavigationRef.current = true;
      history.goBack();
    }
  };

  return (
    <>
      {showSystemSelectModal && (
        <div className="utah-design-system">
          <Modal
            className="modal--medium"
            onClose={handleCancel}
            onEscape={handleCancel}
          >
            <ModalTitle>Select a Water System</ModalTitle>
            <ModalContent id="WS-SearchModal-Content">
              <WaterSystemSearchInput 
                setShowSystemSelectModal={setShowSystemSelectModal}
                selectedWaterSystem={selectedWaterSystem}
                setSelectedWaterSystem={setSelectedWaterSystem}
              />
            </ModalContent>
            <ModalFooter id="WS-SearchModal-Footer">
              <Button onClick={handleCancel}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
};

export default WaterSystemSearchModal;
